// extracted by mini-css-extract-plugin
export default {"cls1":"Timer-cls1__o3","cls2":"Timer-cls2_tSD Timer-cls1__o3","top":"Timer-top_J0x","topBack":"Timer-topBack_JAA","bottom":"Timer-bottom_Z0v"};